// Dependencies
import { all, call, takeEvery, fork, put } from "@redux-saga/core/effects";

// Action Types
import {
    DEVICE_DETAIL_GET_DATA_REQUEST
} from 'Redux/actionTypes';

// Actions
import {
    deviceDetailGetDataRequestResult,
} from 'Redux/actions';

// Helpers
import { clientQuery } from 'Core/data/GraphQLApi';
import { endpoints } from 'Core/defaultValues';
import { ExceptionManager } from 'Core/logManager';

function* getDevice({ payload }) {
    const { esn, id } = payload;
    try {
        let QUERY_UNIT = `
        query getUnit ($id: Int!) {
            result: getUnit (id: $id) {
                id
                company {
                    id
                    name
                    status
                }
                label
                esn
                imei
                simCard {
                    iccId
                    msisdn
                    simProviderAccount {
                        id
                        name
                        simProviderId
                        simProvider {
                            id
                            name
                        }
                    }
                }
                network
                deviceCategory
                status
                statusUpdatedOn
                deviceModel {
                    id
                    name
                    manufacturer {
                        id
                        name
                    }
                }
                linkedMode
                linkedUnitId
                linkedUnit {
                    id
                    label
                    esn
                }
                configStatus
                isRefurbished
                isRMA
                reference
                refurbishedUnit {
                    refurbishedUnitId
                    esn
                }
                lastReading {
                    unitTime
                    serverTime
                    lastMessageTime
                }
                unitConfig {
                    unitId
                    configVersion
                    scriptVersion
                    pulsCustomerId
                    pulsGroup
                    movingFrequency
                    stoppedFrequency
                    password
                    cameraInfo
                    cameraInfoUpdated
                    simState
                    firmwareId
                    hardwareVersion
                    cameraConfig
                    calampApi
                    accountId
                }
                createdBy
                createdOn
            }
        }
        `;

        if (esn) {
            QUERY_UNIT = `
            query searchUnits ($conditions: [UnitSearchInput], $sort: [UnitSortInput], $limit: Int, $offset: Int) {
                result: searchUnits (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                    items {
                        id
                        company {
                            id
                            name
                            status
                        }
                        label
                        esn
                        imei
                        simCard {
                            iccId
                            msisdn
                            simProviderAccount {
                                id
                                name
                                simProviderId
                                simProvider {
                                    id
                                    name
                                }
                            }
                        }
                        network
                        deviceCategory
                        status
                        
                        deviceModel {
                            id
                            name
                            manufacturer {
                                id
                                name
                            }
                        }
                        
                        configStatus
                        isRefurbished
                        isRMA
                        reference
                        refurbishedUnit {
                            refurbishedUnitId
                            esn
                        }
                        lastReading {
                            unitTime
                            serverTime
                            lastMessageTime
                        }
                        unitConfig {
                            unitId
                            configVersion
                            scriptVersion
                            pulsCustomerId
                            pulsGroup
                            movingFrequency
                            stoppedFrequency
                            password
                            cameraInfo
                            cameraInfoUpdated
                            simState
                            firmwareId
                            hardwareVersion
                            cameraConfig
                        }
                        createdBy
                        createdOn
                    }
                }
            }
            `;
        }

        let conditions = { id }

        let data = yield call(
            clientQuery,
            QUERY_UNIT,
            conditions,
            endpoints.GRAPHQL_GENERAL,
        );

        if (data.result) {
            yield put(deviceDetailGetDataRequestResult({ data: data.result }));
        }

    } catch (exc) {
        yield put(deviceDetailGetDataRequestResult({ error: exc }));
        ExceptionManager(exc, "modules/devices/views/.components/Details/redux/saga/", "getDevice", true)
    }
}


function* watchMethods() {
    yield takeEvery(DEVICE_DETAIL_GET_DATA_REQUEST, getDevice);
}

export default function* rootSaga() {
    yield all([fork(watchMethods)]);
}